module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Wenslingen-6f9ad610fdf87099ca3b5104ddbe96a3.svg";